import { render } from "./index-breadcrumb.vue?vue&type=template&id=771c343e"
import script from "./index-breadcrumb.vue?vue&type=script&lang=js"
export * from "./index-breadcrumb.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__